export {default} from '../../core/components/Footer';